import { render, staticRenderFns } from "./LogoPreDefinedSizesSection.vue?vue&type=template&id=232c4110"
import script from "./LogoPreDefinedSizesSection.vue?vue&type=script&lang=ts"
export * from "./LogoPreDefinedSizesSection.vue?vue&type=script&lang=ts"
import style0 from "./LogoPreDefinedSizesSection.vue?vue&type=style&index=0&id=232c4110&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports